const DateIcon = () => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.75 2.25H12V0.75H10.5V2.25H4.5V0.75H3V2.25H2.25C1.4175 2.25 0.75 2.925 0.75 3.75V14.25C0.75 15.075 1.4175 15.75 2.25 15.75H12.75C13.575 15.75 14.25 15.075 14.25 14.25V3.75C14.25 2.925 13.575 2.25 12.75 2.25ZM12.75 14.25H2.25V6.75H12.75V14.25ZM12.75 5.25H2.25V3.75H12.75V5.25ZM3.75 8.25H7.5V12H3.75V8.25Z"
        fill="#666666"
      />
    </svg>
  )
}

export default DateIcon
